var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("yxtbiz-upload", {
        ref: "bizUpload",
        attrs: {
          isBizMixDeploy: "",
          source: "501",
          "app-code": "kng",
          "config-key": "AttachOpenConfigKey",
          "module-name": "knowledgefiles",
          "function-name": "files",
          "files-added": _vm.filesAdded,
          "on-progress": _vm.onProgress,
          "on-uploaded": _vm.onUploaded,
          "on-error": _vm.onError,
          convert: false,
          filters: _vm.filters,
          disabled: _vm.disabled_,
          multipe: "",
          md5: "",
        },
      }),
      _c("yxtbiz-upload", {
        ref: "bizPrivateUpload",
        attrs: {
          isBizMixDeploy: "",
          source: "501",
          "app-code": "kng",
          "config-key": "AttachConfigKey",
          "module-name": "knowledgefiles",
          "function-name": "files",
          "files-added": _vm.filesAdded,
          "on-progress": _vm.onProgress,
          "on-uploaded": _vm.onUploaded,
          "on-error": _vm.onError,
          convert: false,
          filters: _vm.filters,
          disabled: _vm.disabled_,
          isLocal: _vm.uploadConfig.privateEnv,
          localGroupId: _vm.uploadConfig.serverGroupId,
          transcodeOptions: _vm.transcodeOptions,
          multipe: "",
          md5: "",
        },
      }),
      _c(
        "yxt-button",
        { attrs: { disabled: _vm.disabled_ }, on: { click: _vm.clickUpload } },
        [
          _c("yxt-svg", {
            staticClass: "v-middle",
            attrs: {
              width: "16px",
              height: "16px",
              "remote-url": _vm.$staticBaseUrl + "ufd/407a24/kng/pc/svg/pc",
              "icon-class": "upload-attachment",
            },
          }),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("pc_kng_lbl_upload_attachment" /*上传附件*/)) +
              "\n  "
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "color-gray-6 mt8 lh24" },
        [
          _c("span", { staticClass: "mr2" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t(
                    "pc_kng_lbl_upload_attachment_tip" /** 最多上传50个附件，学员观看该课程时可以下载附件，支持类型：视频/音频/文档/图片/压缩包 */
                  )
                ) +
                "\n    "
            ),
          ]),
          _c(
            "yxt-tooltip",
            { attrs: { effect: "dark", placement: "bottom" } },
            [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "pc_kng_lbl_upload_attachment_video" /*视频格式：wmv、mp4、flv、avi、rmvb、mpg、mkv、mov，单个视频小于2G*/
                      )
                    ) +
                    "\n        "
                ),
                _c("br"),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "pc_kng_lbl_upload_attachment_audio" /*音频格式：w4v、m4a、wma、wav、mp3、amr，单个音频小于200M*/
                      )
                    ) +
                    "\n        "
                ),
                _c("br"),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "pc_kng_lbl_upload_attachment_doc" /*文档格式：doc、docx、ppt、pptx、xls、xlsx、pps、pdf，单个文档小于100M*/
                      )
                    ) +
                    "\n        "
                ),
                _c("br"),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "pc_kng_lbl_upload_attachment_img" /*图片格式：jpg、jpeg、gif、png、bmp、ico、svg，单个图片小于10M*/
                      )
                    ) +
                    "\n        "
                ),
                _c("br"),
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "pc_kng_lbl_upload_attachment_zip" /*压缩包格式：.zip、rar单个压缩包小于1G*/
                      )
                    ) +
                    "\n      "
                ),
              ]),
              _c("yxt-svg", {
                staticClass: "hand v-mid",
                attrs: {
                  width: "16px",
                  height: "16px",
                  "icon-class": "icons/question-cirlce-o",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._l(_vm.list, function (item) {
        return _c(
          "div",
          {
            key: item.fileId || item.uuid,
            staticClass:
              "yxtbiz-flex-center yxtbiz-kng-operator__attachment-item",
            class:
              item.status === 1
                ? "yxtbiz-kng-operator__attachment-item--error"
                : "",
          },
          [
            _c("yxt-svg", {
              staticClass: "color-gray-7",
              attrs: {
                "remote-url":
                  _vm.$staticBaseUrl + "ufd/407a24/kng/pc/svg/pcsvg",
                width: "16px",
                height: "16px",
                "icon-class": "kng_href",
              },
            }),
            _c(
              "span",
              { staticClass: "yxtbiz-flex-1 yxtbiz-flex-center ml4 mr32" },
              [
                _c("span", { staticClass: "yxtbiz-mw400 ellipsis-1" }, [
                  _vm._v(_vm._s(item.fileName)),
                ]),
                item.serverGroupId
                  ? _c(
                      "yxt-tooltip",
                      {
                        attrs: {
                          placement: "top",
                          content: _vm.$t(
                            "pc_biz_kng_tip_upload_evn" /** 存储在私有云 */
                          ),
                        },
                      },
                      [
                        _c("yxt-svg", {
                          staticClass: "ml4",
                          attrs: {
                            width: "30px",
                            height: "20px",
                            "remote-url":
                              _vm.$staticBaseUrl + "ufd/407a24/kng/pc/svg/PC",
                            "icon-class": "private-cloud",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            item.status === 0
              ? _c("yxt-progress", {
                  staticClass: "yxtbiz-w195 mr20",
                  attrs: { percentage: item.percentage, "stroke-width": 4 },
                })
              : _vm._e(),
            item.status === 1
              ? _c("span", { staticClass: "mr10" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "pc_kng_category_lbl_importInfo_fail" /** 上传失败 */
                      )
                    )
                  ),
                ])
              : _vm._e(),
            _c("yxt-svg", {
              staticClass:
                "color-gray-7 yxtbiz-kng-operator__attachment-delete",
              attrs: {
                width: "16px",
                height: "16px",
                "remote-url":
                  _vm.$staticBaseUrl + "ufd/407a24/kng/pc/svg/pcsvg",
                "icon-class": "kng_remove",
              },
              nativeOn: {
                click: function ($event) {
                  return _vm.del(item)
                },
              },
            }),
          ],
          1
        )
      }),
      _c("div"),
      _c(
        "yxt-dialog",
        {
          attrs: {
            title: _vm.$t("pc_kng_lbl_upload_attachment" /** 上传附件 */),
            visible: _vm.visible,
            width: "480px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("div", [
                _vm._v(
                  _vm._s(_vm.$t("pc_biz_kng_lbl_upload_to" /** 上传到 */))
                ),
              ]),
              _vm.mixinConfig.attachmentType === 2
                ? _c(
                    "yxt-radio-group",
                    {
                      model: {
                        value: _vm.uploadConfig.privateEnv,
                        callback: function ($$v) {
                          _vm.$set(_vm.uploadConfig, "privateEnv", $$v)
                        },
                        expression: "uploadConfig.privateEnv",
                      },
                    },
                    [
                      _c("yxt-radio", { attrs: { label: false } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "pc_kng_courseware_lbl_public_cloud" /**公有云 */
                            )
                          )
                        ),
                      ]),
                      _c("yxt-radio", { attrs: { label: true } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("pc_biz_kng_tip_localCloud" /**私有云 */)
                          )
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.uploadConfig.privateEnv &&
              _vm.mixinConfig.serviceGroupList.length
                ? _c(
                    "div",
                    {
                      class: {
                        "yxtbiz-kng-operator__server-group":
                          _vm.mixinConfig.attachmentType === 2,
                      },
                    },
                    [
                      _c(
                        "yxt-radio-group",
                        {
                          model: {
                            value: _vm.uploadConfig.serverGroupId,
                            callback: function ($$v) {
                              _vm.$set(_vm.uploadConfig, "serverGroupId", $$v)
                            },
                            expression: "uploadConfig.serverGroupId",
                          },
                        },
                        _vm._l(
                          _vm.mixinConfig.serviceGroupList,
                          function (item) {
                            return _c(
                              "yxt-radio",
                              { key: item.id, attrs: { label: item.id } },
                              [
                                _vm._v(
                                  _vm._s(item.serviceGroupName) + "\n          "
                                ),
                              ]
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "yxt-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_kng_btn_cancel" /** 取消 */)))]
              ),
              _c(
                "yxt-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v(_vm._s(_vm.$t("pc_biz_common_btn_sure" /** 确定 */)))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }